module.exports = __webpack_public_path__ + "static/media/copypet.64fb5cc3.jpg";